export default __webpack_public_path__ + "static/media/cloud-ip.f8eb0cab.svg";